import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import { getRegionConfig, getMallsByRegion } from "./config/regionConfig";
import AppButton from "../../Components/MerchantButton";

function MallSelector({ navigation, primaryDetails, setPrimaryDetails, selectedRegion }) {
  const [isError, setIsError] = useState({});
  const [regionConfig, setRegionConfig] = useState(null);
  const [malls, setMalls] = useState([]);

  

  useEffect(() => {
    if (!selectedRegion) {
      if (navigation && typeof navigation.go === "function") {
        navigation.go("region-form");
      }
    }
  }, [selectedRegion, navigation]);

  useEffect(() => {
    
    if (selectedRegion) {
      const config = getRegionConfig(selectedRegion);
      const mallList = getMallsByRegion(selectedRegion);
      
      if (config && mallList) {
        setRegionConfig(config);
        setMalls(mallList);
        
       
        const initialErrors = {};
        initialErrors[config.formFields.mall_name] = false;
        setIsError(initialErrors);
      }
    }
  }, [selectedRegion]);

  // Clear validation error when mall name is auto-filled
  useEffect(() => {
    if (regionConfig) {
      const mallFieldName = regionConfig.formFields.mall_name;
      const mallValue = primaryDetails[mallFieldName] || primaryDetails.mall_name;
      
      if (mallValue && isError[mallFieldName]) {
        setIsError(prev => ({
          ...prev,
          [mallFieldName]: false
        }));
      }
    }
  }, [primaryDetails, regionConfig, isError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // If changing the main mall dropdown and it's not "Others", clear other_mall_name
    if (name === regionConfig?.formFields?.mall_name && value !== "Others") {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: value,
        other_mall_name: "" // Clear custom mall name when selecting a predefined mall
      }));
    } else {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    if (!regionConfig) return false;

    const errors = {};
    const mall_name = regionConfig.formFields.mall_name;
    
    if (!primaryDetails[mall_name] && !primaryDetails.mall_name) {
      errors[mall_name] = true;
      toast.error("Please select a mall name", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    // Validate other_mall_name if "Others" is selected
    if (primaryDetails[mall_name] === "Others" && !primaryDetails.other_mall_name) {
      errors.other_mall_name = true;
      toast.error("Please enter the other mall name", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    if (!regionConfig) return false;

    const mall_name = regionConfig.formFields.mall_name;
    const isMallSelected = !!primaryDetails[mall_name] || !!primaryDetails.mall_name;
    const isOtherMallValid = primaryDetails[mall_name] !== "Others" || !!primaryDetails.other_mall_name;

    return isMallSelected && isOtherMallValid;
  };
  const handleNext = () => {
    if (validateForm()) {
      const mall_name = regionConfig.formFields.mall_name;
      

      if (primaryDetails[mall_name] === "Others") {
        navigation.go("other-mall-details");
      } else {
        
        navigation.go("other-mall-details");
      }
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  
  if (!selectedRegion) {
    return (
      <div className="form-bg form-loading">
        <div>Redirecting to Region...</div>
      </div>
    );
  }

  if (!regionConfig || !malls.length) {
    return (
      <div className="form-bg form-loading">
        <div>Loading...</div>
      </div>
    );
  }

  const { formFields, title } = regionConfig;
  const mall_name = formFields.mall_name;

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
         

          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">{title} - MALLS</h4>
                <p className="form-desc">Please select your mall location</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  <Form.Group className="mb-5" controlId={mall_name}>
                    <Form.Label className="form-label">
                      Mall Name <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name={mall_name}
                      value={primaryDetails[mall_name] || primaryDetails.mall_name || ""}
                      onChange={handleInputChange}
                      className={`form-input${
                        isError[mall_name] ? " form-input-error" : ""
                      }`}
                    >
                      <option value="">Select Mall Name</option>
                      {(() => {
                        // If mall_type is 'Non-Mall', only show 'Others'
                        const mallTypeField = regionConfig?.formFields?.mall_type;
                        if (mallTypeField && primaryDetails[mallTypeField] === 'Non-Mall (located in a compound/grouped with other merchants)') {
                          return (
                            <option key="mall-others" value="Others">Others</option>
                          );
                        }
                        
                        // Get mall name from API if available
                        const mallFieldName = regionConfig?.formFields?.mall_name;
                        const mallNameFromAPI = primaryDetails[mallFieldName] || primaryDetails.mall_name;
                        // Combine existing malls with API mall name if not already included
                        const allMalls = mallNameFromAPI && !malls.includes(mallNameFromAPI) 
                          ? [...malls, mallNameFromAPI] 
                          : malls;
                        
                        return allMalls.map((mall, index) => (
                          <option key={`mall-${index}`} value={mall}>
                            {mall}
                          </option>
                        ));
                      })()}
                    </Form.Select>
                    {isError[mall_name] && (
                      <div className="form-error">
                        Please select a mall name
                      </div>
                    )}
                    <div>
                    <p className="form-note-text">
                     <em>Note: Choose Mall Name</em>
                    </p>
                  </div>
                  </Form.Group>

                  {/* Other Mall Name - Only show if "Others" was selected */}
                  {(primaryDetails[mall_name] === "Others" || primaryDetails.other_mall_name) && (
                    <Form.Group className="mb-5" controlId="other_mall_name">
                      <Form.Label className="form-label">
                        Other Mall Name <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="other_mall_name"
                        value={primaryDetails.other_mall_name || ""}
                        onChange={(e) => {
                          const customMallName = e.target.value;
                          setPrimaryDetails(prev => ({
                            ...prev,
                            other_mall_name: customMallName,
                            [mall_name]: customMallName.trim() || "Others" // Update mall_name with custom value or revert to "Others"
                          }));
                          
                          // Clear errors
                          if (isError.other_mall_name || isError[mall_name]) {
                            setIsError(prev => ({
                              ...prev,
                              other_mall_name: false,
                              [mall_name]: false
                            }));
                          }
                        }}
                        placeholder="Enter mall name..."
                        className={`form-input${isError.other_mall_name ? " form-input-error" : ""}`}
                      />
                      {isError.other_mall_name && (
                        <div className="form-error">
                          Please enter the mall name
                        </div>
                      )}
                      <div>
                        <p className="form-note-text">
                          <em>"Note: Put Building name if located in a bldg."</em>
                        </p>
                      </div>
                    </Form.Group>
                   )} 
                

  
                  <div className="form-nav-btns">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MallSelector;
